<template>
    <div class="price" 
        :class="'price_' + type">
        <span class="price__currency">$</span>
        <span class="price__value">
            {{ price }}
        </span>
        <span class="price__period">/month</span>
    </div>
</template>

<script>
export default {
    name: 'Price',
    props: {
        price: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            default: 'large',
            validator: function (value) {
                const allowedTypeValues = ['large', 'small']
                return allowedTypeValues.includes(value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.price {
    display: flex;
    color: $rfx-dark-march;

    &__currency {
        font-size: 24px;
        font-weight: 700;
        margin-top: 2px;
        align-self: flex-start;
    }

    &__value {
        font-size: 40px;
        font-weight: 700;
    }

    &__period {
        font-size: 16px;
        margin-bottom: 4px;
        margin-left: 4px;
        color: $rfx-text-dark-mid-contrast;
        align-self: flex-end;
    }

    &_small {
        .price {
            &__currency {
                font-size: 14px;
            }

            &__value {
                font-size: 24px;
            }

            &-period {
                font-size: 14px;
            }
        }
    }
}

</style>